import React from 'react'
import {
  CardModalOverlay,
  CardModalContainer,
  CardModalWrapper,
  ModalTitle,
  CardModalDescription,
  CloseLink,
} from './style'
import { FormattedMessage } from 'react-intl'

interface Props {
  open: boolean
  onClose: () => void
}

const CardInfoModal: React.FC<Props> = ({ open, onClose }) => {
  if (!open) return null

  return (
    <CardModalOverlay onClick={onClose}>
      <CardModalContainer onClick={(e) => e.stopPropagation()}>
        <CardModalWrapper>
          <ModalTitle style={{ marginTop: '0px' }}>
            <FormattedMessage id="E- learning" defaultMessage={'E- learning'} />
          </ModalTitle>

          <CardModalDescription>
            <FormattedMessage
              id="Through various multimedia and interactive activities, this online module will teach you more about this course topic. Then, there will be a brief assessment to check your knowledge."
              defaultMessage={
                'Through various multimedia and interactive activities, this online module will teach you more about this course topic. Then, there will be a brief assessment to check your knowledge.'
              }
            />
          </CardModalDescription>

          <CloseLink onClick={onClose}>
            <FormattedMessage id="Tap to close" defaultMessage={'Tap to close'} />
          </CloseLink>
        </CardModalWrapper>
      </CardModalContainer>
    </CardModalOverlay>
  )
}

export default CardInfoModal
